import { SUPPORTED_LOCALES, FALLBACK_LOCALE } from "./config.js";

const isPlainObject = (value) =>
  value !== null && typeof value === "object" && !Array.isArray(value);

const isMissing = (value) =>
  value === undefined || value === null || value === "";

export function isTranslationLeaf(node) {
  if (!isPlainObject(node)) return false;
  const keys = Object.keys(node);
  return (
    keys.length > 0 && keys.every((key) => SUPPORTED_LOCALES.includes(key))
  );
}

export function resolveLeaf(leaf, locale) {
  const value = leaf[locale];
  if (!isMissing(value)) return value;
  const fallback = leaf[FALLBACK_LOCALE];
  return isMissing(fallback) ? "" : fallback;
}

function localizeNode(node, locale) {
  if (Array.isArray(node)) {
    return node.map((item) => localizeNode(item, locale));
  }
  if (isTranslationLeaf(node)) {
    return resolveLeaf(node, locale);
  }
  if (isPlainObject(node)) {
    const result = {};
    for (const [key, value] of Object.entries(node)) {
      result[key] = localizeNode(value, locale);
    }
    return result;
  }
  return node;
}

const localizeCache = new WeakMap();

export function localize(tree, locale) {
  if (!isPlainObject(tree) && !Array.isArray(tree)) return tree;

  let byLocale = localizeCache.get(tree);
  if (!byLocale) {
    byLocale = new Map();
    localizeCache.set(tree, byLocale);
  }
  if (!byLocale.has(locale)) {
    byLocale.set(locale, localizeNode(tree, locale));
  }
  return byLocale.get(locale);
}

export function getByPath(tree, path) {
  return path
    .split(".")
    .reduce(
      (node, segment) => (isPlainObject(node) ? node[segment] : undefined),
      tree,
    );
}

export function interpolate(template, params) {
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (match, name) =>
    Object.prototype.hasOwnProperty.call(params, name)
      ? String(params[name])
      : match,
  );
}
